<template>
  <div class="row align-items-start mb-2">
    <div
      v-for="field in percentageFields"
      :key="field.name"
      class="form-group col-lg-3"
    >
      <label class="sr-only">{{ field.label }}</label>
      <input
        type="number"
        class="form-control"
        :min="percentageMin"
        :max="percentageMax"
        step="0.01"
        :aria-label="field.label"
        :value="entry[field.name]"
        :disabled="disabled"
        @input="onPercentageInput(field.name, $event)"
      />
      <span v-if="errors[field.name]" class="small text-danger">{{ errors[field.name] }}</span>
    </div>
    <div class="form-group col-lg-5">
      <label class="sr-only">Label</label>
      <input
        type="text"
        class="form-control"
        :maxlength="labelMaxLength"
        aria-label="Label"
        :value="entry.label"
        :disabled="disabled"
        @input="onLabelInput"
      />
      <span v-if="errors.label" class="small text-danger">{{ errors.label }}</span>
      <span v-if="errors.duplicate" class="small text-danger">{{ errors.duplicate }}</span>
    </div>
    <div class="form-group col-lg-1 d-flex align-items-center justify-content-end remove-entry-wrapper">
      <button
        type="button"
        class="btn btn-link text-danger p-0"
        aria-label="Verwijder overwerkregel"
        :disabled="!canRemove || disabled"
        @click="$emit('remove')"
      >
        <i class="far fa-trash-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { LABEL_MAX_LENGTH, PERCENTAGE_MAX, PERCENTAGE_MIN } from './overtimeHelpers';

export default {
  props: {
    entry: {
      type: Object,
      required: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      percentageMin: PERCENTAGE_MIN,
      percentageMax: PERCENTAGE_MAX,
      labelMaxLength: LABEL_MAX_LENGTH,
      percentageFields: [
        { name: 'shift_allowance_percentage', label: 'Ploegentoeslag' },
        { name: 'overtime_percentage', label: 'Overwerkpercentage' }
      ]
    };
  },
  methods: {
    onPercentageInput(field, event) {
      const value = event && event.target ? event.target.value : '';
      const parsedValue = value === '' ? '' : Number(value);

      this.$emit('update-entry', { field, value: parsedValue });
      this.$emit('input-change');
    },
    onLabelInput(event) {
      const value = event && event.target ? event.target.value : '';

      this.$emit('update-entry', { field: 'label', value });
      this.$emit('input-change');
    }
  }
};
</script>

<style lang="scss" scoped>
.remove-entry-wrapper {
  min-height: 38px;
}
</style>
